import { CuteIcon } from '@/shared/components/CuteIcon'
import type { ReactNode } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'

interface AppShellProps {
  header?: ReactNode
  children?: ReactNode
}

export function AppShell({ header, children }: AppShellProps) {
  const { pathname } = useLocation()
  const routeGroup = pathname.split('/')[1] ?? ''
  const todayCurrent = pathname === '/' || routeGroup === 'metrics' || routeGroup === 'sleep'
  const workoutsCurrent = routeGroup === 'workouts'
  const settingsCurrent = pathname === '/settings'

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        跳到主要内容
      </a>
      <header className="app-header">
        <span className="app-brand"><span aria-hidden="true"><CuteIcon name="bear" /></span> CareBaby</span>
        {header}
        <Link
          className="settings-link"
          aria-label="设置"
          to="/settings"
          aria-current={settingsCurrent ? 'page' : undefined}
        >
          <span aria-hidden="true"><CuteIcon name="settings" /></span>
        </Link>
      </header>
      <main id="main-content" tabIndex={-1}>
        {children ?? <Outlet />}
        <footer className="icon-credit"><a href="https://icons8.com" target="_blank" rel="noopener noreferrer">Icons by Icons8</a></footer>
      </main>
      <nav className="bottom-tabs" aria-label="主要导航">
        <Link to="/" aria-current={todayCurrent ? 'page' : undefined}>
          <span aria-hidden="true"><CuteIcon name="flower" /></span><span>今日状态</span>
        </Link>
        <Link to="/workouts" aria-current={workoutsCurrent ? 'page' : undefined}>
          <span aria-hidden="true"><CuteIcon name="workout" /></span><span>健身记录</span>
        </Link>
      </nav>
    </div>
  )
}
